interface Environment {
  apiUrl: string
  domain: string
  socketUrl: string
}

function validateEnvironment(): Environment {
  const required = ["VITE_API_URL", "VITE_DOMAIN", "VITE_SOCKET_URL"]
  const missing = required.filter((key) => !import.meta.env[key])

  if (missing.length > 0) {
    throw new Error(`Missing required environment variables: ${missing.join(", ")}`)
  }

  return {
    apiUrl: import.meta.env.VITE_API_URL,
    domain: import.meta.env.VITE_DOMAIN,
    socketUrl: import.meta.env.VITE_SOCKET_URL,
  }
}

export const environment = validateEnvironment()

